(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.section-header');
      this.setHeaderHeight();
      this.resizeObserver = new ResizeObserver(() => {
        if (this.raf) cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.setHeaderHeight());
      });
      this.resizeObserver.observe(this);
    }

    setHeaderHeight() {
      const height = this.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--header-bottom', `${height}px`);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (this.raf) cancelAnimationFrame(this.raf);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-engineere-slider"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-engineer-slider')) {
    customElements.define(
      'product-engineer-slider',
      class ProductEngineerSlider extends HTMLElement {
        constructor() {
          super();
          this.swiper = null;
        }

        connectedCallback() {
          // Only initialize if Swiper is available
          if (typeof Swiper === 'undefined') {
            console.warn('Swiper library not loaded');
            return;
          }

          this.initializeSwiper();
        }

        disconnectedCallback() {
          // Clean up Swiper instance when element is removed
          if (this.swiper) {
            this.swiper.destroy(true, true);
            this.swiper = null;
          }
        }

        initializeSwiper() {
          const swiperContainer = this.querySelector('.engineer-product__swiper');
          if (!swiperContainer) return;

          // Destroy existing instance if it exists
          if (this.swiper) {
            this.swiper.destroy(true, true);
          }

          // Initialize new Swiper instance with scoped selectors
          this.swiper = new Swiper(swiperContainer, {
            loop: false,
            spaceBetween: 0,
            slidesPerView: 'auto',
            centeredSlides: false,
            navigation: {
              nextEl: this.querySelector('.engineer-product__nav-next'),
              prevEl: this.querySelector('.engineer-product__nav-prev'),
            },
          });
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
